import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c82c441"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "runner-list-grid" }
const _hoisted_2 = {
  key: 0,
  class: "runner-table"
}
const _hoisted_3 = ["colspan"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "ranks",
  width: "1"
}, "Rank", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Runner", -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = ["width"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ranks" }
const _hoisted_14 = { class: "rank" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/TwitchGlitchWhite.svg" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/YoutubeWhite.svg" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_22 = {
  key: 1,
  class: "fas fa-minus darker"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  colspan: "999",
  class: "has-text-centered"
}
const _hoisted_25 = {
  key: 1,
  class: "runner-cards"
}
const _hoisted_26 = ["width"]
const _hoisted_27 = ["width"]
const _hoisted_28 = { class: "runner-info" }
const _hoisted_29 = { class: "headline" }
const _hoisted_30 = { class: "rank" }
const _hoisted_31 = ["href"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/TwitchGlitchWhite.svg" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["href"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/YoutubeWhite.svg" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "game-symbols" }
const _hoisted_38 = {
  key: 2,
  class: "p-4 has-text-centered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentLoader = _resolveComponent("ContentLoader")!
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$store.state.isMobile)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                colspan: 3+_ctx.games.length
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input",
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.applySearch()))
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ])
              ], 8, _hoisted_3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("th", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortPoints()))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["sort-button", {ascending: _ctx.sortPointDirection == 1, descending: _ctx.sortPointDirection == -1}])
                }, "Points", 2)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: game.Id,
                  onClick: ($event: any) => (_ctx.filter(game)),
                  class: "game-header"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["filter-button", {filterIgnore: _ctx.filters[game.Id!] == 0, filterExclude: _ctx.filters[game.Id!] == -1, filterRequire: _ctx.filters[game.Id!] == 1}])
                  }, _toDisplayString(game.UrlStub), 3)
                ], 8, _hoisted_6))
              }), 128))
            ])
          ]),
          (!_ctx.runnerList)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(100, (i) => {
                  return _createElementVNode("tr", { key: i }, [
                    _hoisted_8,
                    _createElementVNode("td", null, [
                      _createVNode(_component_ContentLoader, {
                        width: "170",
                        height: "18",
                        "primary-color": "#1f2a3c",
                        "secondary-color": "#2c3b55"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("rect", {
                            x: "0",
                            y: "5",
                            rx: "2",
                            ry: "2",
                            width: (150 + Math.random() * 20),
                            height: "15"
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_10,
                    _hoisted_11
                  ])
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (_ctx.runnerList)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.runnerList, (user, i) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: user.UserId
                  }, [
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(user.rank), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (user.CountryDesignation)
                        ? (_openBlock(), _createBlock(_component_country_flag, {
                            key: 0,
                            country: user.CountryDesignation,
                            size: "small",
                            title: `${user.CountryDesignation} flag`
                          }, null, 8, ["country", "title"]))
                        : _createCommentVNode("", true),
                      _createTextVNode("  "),
                      _createVNode(_component_router_link, {
                        to: '/profiles/' + user.Username
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user.Username), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (user.TwitchAccount)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: 'https://twitch.tv/' + user.TwitchAccount,
                            class: "social-link twitch"
                          }, _hoisted_17, 8, _hoisted_15))
                        : _createCommentVNode("", true),
                      (user.YoutubeUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: user.YoutubeUrl,
                            class: "social-link youtube"
                          }, _hoisted_20, 8, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(user.Points), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: game.Id,
                        class: "game-symbol"
                      }, [
                        (user.SubmittedGames.indexOf(game.Id) >= 0)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                          : (_openBlock(), _createElementBlock("i", _hoisted_22))
                      ]))
                    }), 128))
                  ])), [
                    [_vShow, user.show]
                  ])
                }), 128)),
                (!_ctx.loadedFull)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("button", {
                          class: "button is-primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadFullList()))
                        }, "Load More Runners")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          (!_ctx.runnerList)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(100, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "runner-card"
                }, [
                  _createVNode(_component_ContentLoader, {
                    width: "250",
                    height: "75",
                    "primary-color": "#1f2a3c",
                    "secondary-color": "#2c3b55"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("rect", {
                        x: "25",
                        y: "5",
                        rx: "2",
                        ry: "2",
                        width: (150 + Math.random() * 50),
                        height: "15"
                      }, null, 8, _hoisted_26),
                      _createElementVNode("rect", {
                        x: "25",
                        y: "30",
                        rx: "2",
                        ry: "2",
                        width: (150 + Math.random() * 50),
                        height: "15"
                      }, null, 8, _hoisted_27)
                    ]),
                    _: 1
                  })
                ])
              }), 64))
            : _createCommentVNode("", true),
          (_ctx.runnerList)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.runnerList, (user, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: user.UserId,
                  class: "runner-card"
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(i+1), 1),
                      _createElementVNode("div", null, [
                        (user.CountryDesignation)
                          ? (_openBlock(), _createBlock(_component_country_flag, {
                              key: 0,
                              country: user.CountryDesignation,
                              size: "small",
                              title: `${user.CountryDesignation} flag`
                            }, null, 8, ["country", "title"]))
                          : _createCommentVNode("", true),
                        _createTextVNode("  "),
                        _createVNode(_component_router_link, {
                          to: '/profiles/' + user.Username
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(user.Username), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("div", null, _toDisplayString(user.Points) + " points", 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (user.TwitchAccount)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: 'https://twitch.tv/' + user.TwitchAccount,
                            class: "social-link twitch"
                          }, _hoisted_33, 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      (user.YoutubeUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: user.YoutubeUrl,
                            class: "social-link youtube"
                          }, _hoisted_36, 8, _hoisted_34))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: game.Id,
                        class: _normalizeClass(["game-symbol", {'submitted': user.SubmittedGames.indexOf(game.Id) >= 0}])
                      }, _toDisplayString(game.UrlStub), 3))
                    }), 128))
                  ])
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (!_ctx.loadedFull)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("button", {
                  class: "button is-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadFullList()))
                }, "Load More Runners")
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}